import { ContainerYardOperationDialog } from '@host/components/container-change-position-dialog/ContainerYardOperationDialog'
import { ContainerYardOperationViewStore } from '@host/components/container-change-position-dialog/ContainerYardOperationViewStore'
import { useGeneralCargoOrderLocations } from '@host/hooks/useGeneralCargoOrderLocations'
import { parseBaplie } from '@host/utils/baplie-parser-utils'
import { usePlanningStore, VesselVisitLoadListPage } from '@tom-ui/planning'
import { OrderResponseDto } from '@tom-ui/planning/app/api'
import { GeneralCargoOrderReservationDialog, useStorageStore } from '@tom-ui/storage'
import { PATHS, useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router'

export const VesselVisitLoadList = withAuthenticationRequired(
  observer(() => {
    const { id } = useParams()
    const navigate = useNavigate()

    const { vesselVisitQueryService, vesselVisitItemStore, orderItemStore, containerItemStore } =
      usePlanningStore()

    const { tenantConfigStore, generalCargoOrderReservationUIStore } = useStorageStore()

    const vesselVisitId = Number(id)
    if (!vesselVisitId) {
      navigate(PATHS.visits.vesselVisits.url)
    }

    const containerYardOperationViewStore = useMemo(() => {
      return new ContainerYardOperationViewStore()
    }, [])

    const vesselVisitItem = computed(() => vesselVisitItemStore.elements[vesselVisitId]).get()

    useAsyncFetch(async () => {
      await vesselVisitQueryService.fetchById(vesselVisitId)
      await orderItemStore.fetchByVisitId(vesselVisitId)
      await containerItemStore.fetchByVisitId(vesselVisitId)
    }, [vesselVisitId, vesselVisitQueryService, orderItemStore, containerItemStore])

    const handleGeneralCargoReservation = (order: OrderResponseDto) => {
      generalCargoOrderReservationUIStore.toggleDialog(
        order.id,
        undefined,
        order.plannedCargoAmount ?? 0,
        order.direction,
      )
    }

    const { reservationUpdate, handleGetOrderReservations } = useGeneralCargoOrderLocations()

    return (
      <>
        <VesselVisitLoadListPage
          vesselVisitItem={vesselVisitItem}
          containerYardOperationViewStore={containerYardOperationViewStore}
          parseBaplie={parseBaplie}
          onOpenGeneralCargoReservation={
            tenantConfigStore.skipYardPlanning ? undefined : handleGeneralCargoReservation
          }
          getOrderReservationsFunc={handleGetOrderReservations}
          reservationUpdate={reservationUpdate ?? undefined}
        />
        <ContainerYardOperationDialog store={containerYardOperationViewStore} />
        <GeneralCargoOrderReservationDialog />
      </>
    )
  }),
)
